import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../actions/index';

//import Panel from '../Panel/Panel';
import Header from '../Header/Header';
import LoadScreen from '../LoadScreen/LoadScreen';
//import TextDisplay from '../TextDisplay/TextDisplay';

import './LauncherMenu.css';

// const setIsDisabled = function(launcher) {
//   if(launcher.action === 'openApp') {
//     launcher.disabled = !(this && this[launcher.destinaton]);
//   } else {
//     launcher.disabled = false;
//   }
//   return launcher;
// }

const getLaunchBoxes = function(launchers, appStatus) {
  return launchers
          .filter(launcher => launcher.type === 'launch-box')
          //.map(setIsDisabled.bind(this));
}
const getLaunchBars = function(launchers, appStatus) {
  return launchers
          .filter(launcher => launcher.type === 'launch-bar')
          //.map(setIsDisabled.bind(this));
}

const handleAction = function(launcher) {
  //const self = this;
  const props = this.props;
  const waitTime = (launcher.waitTime || 15) * 1000;

  if(launcher.action && props[launcher.action]) {
    // console.log('running action', launcher.action, 'to', launcher.destination);
    props[launcher.action](launcher.destination, launcher.title);

    //If launching an app, set loading state
    if(launcher.action === 'openApp') {
      // this.setState({ loading: true });
      props.setLoader(true);

      // const resetLoader = () => (self.setState({ loading: false }));
      const resetLoader = () => (props.setLoader(false));
      window.setTimeout(resetLoader, waitTime);
    }
  } else {
    console.log('Not doing anything, action for', launcher, ' is not specified on', props);
  }
}


class LauncherMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
      const electron = window.require && window.require('electron');
      const ipcRenderer = electron && electron.ipcRenderer;
      const props = this.props;

      if(ipcRenderer) {
        ipcRenderer.once('checked-apps', function(event, checkedApps) {
          console.log('got back checked apps', checkedApps);
          const checkedAppsObj = (checkedApps || []).reduce(function(pre, x) {
			pre[x.appName] = x.exists;
			return pre;
		  }, {});
          console.log('converted to checkedAppsObj', checkedAppsObj);
          props.setCheckedApps(checkedAppsObj);
        });
        ipcRenderer.send('check-apps');
      }
  }

  render() {
    const props = this.props;
    return (
      <section>
      { this.state.loading && <LoadScreen /> }
      { !this.state.loading &&
        (<section className={`launcherMenu ${props.data.fullscreen ? 'fullscreen' : ''} ${props.data.style || ''}`}>
          <section className={`launcherMenu__header`}>
            {
              (props.data.title || props.data.subtitle || props.data.pretitle) &&
              <Header
                title={props.data.title}
                subtitle={props.data.subtitle}
                pretitle={props.data.pretitle}
              />
            }
          </section>
          <section className={`launcherMenu__boxes ${props.data.style ? props.data.style : ''}`}>
            {getLaunchBoxes(props.data.launchers, props.checkedApps).map((launcher, pos) => (
              <section key={"launch-box-"+pos}
                className={"launch-box "+(launcher.disabled ? 'disabled' : '')}
                onClick={launcher.disabled ? null : handleAction.bind(this, launcher)}>
                <section className="progress-bar"></section>
                <img className="launch-image" src={launcher.image} alt={launcher.title} />
                <div className="launch-title">
                  {launcher.title}
                </div>
              </section>
            ))}
          </section>          <section className={`launcherMenu__bars ${props.data.style ? props.data.style : ''}`}>
            {getLaunchBars(props.data.launchers, props.checkedApps).map((launcher, pos) => (
              <section key={"launch-bar-"+pos}
                className={"launch-bar "+(launcher.disabled ? 'disabled' : '')}
                onClick={launcher.disabled ? null : handleAction.bind(this, launcher)}
                style={{ backgroundImage: `url(${launcher.image})`}}>
                <div>{launcher.title}</div>
              </section>
            ))}
          </section>
        </section>)
      }
      </section>
    )
  }
}

LauncherMenu.propTypes = {
  data: propTypes.shape({
    title: propTypes.string,
    subtitle: propTypes.string,
    pretitle: propTypes.string,
    fullscreen: propTypes.bool,
    style: propTypes.string,
    launchers: propTypes.array,
  }),
  checkedApps: propTypes.object,
  loading: propTypes.bool,
  setLoader: propTypes.func.isRequired,
};

function mapStateToProps(state) {
  // console.log('updating state in mapStateToProps', state.news.loading);
  return {
    loading: state.news.loading,
    loader: state.navigation.loader,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    goToSection: (sectionID) => {
      dispatch(actions.goToSection(sectionID));
    },
    goToGroup: (groupID) => {
      dispatch(actions.goToGroup(groupID));
    },
    goToStage: (stageID) => {
      dispatch(actions.goToStage(stageID));
    },
    setModal: (media) => {
      dispatch(actions.setModal(media));
    },
    setCheckedApps: (apps) => {
      dispatch(actions.setCheckedApps(apps));
    },
    openUrl: (media, title) => {
      dispatch(actions.setModal({
        type: "pdf",
        title: title,
        content: media
      }));
    },
    openApp: (appId) => {
      // console.log('Want to ask electron internals to open-app', appId);

      const electron = window.require && window.require('electron');
      const ipcRenderer = electron && electron.ipcRenderer;

      if(ipcRenderer) {
        ipcRenderer.send('open-app', appId);
        console.log('Asked electron internals to open-app', appId);
      }
    },
    setLoader: (bool) => {
      dispatch(actions.setLoader(bool));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LauncherMenu);



// WEBPACK FOOTER //
// ./src/components/LauncherMenu/LauncherMenu.js